import { QRCodeSVG } from "qrcode.react";

// Controle de Estoque — QR simplificado: apenas o ID do produto (leitura rápida).
// O scanner do checklist busca os dados do produto no sistema pelo ID.
export function buildQrPayload(item) {
  return item.id;
}

const fmt = (d) => (d ? String(d).slice(0, 10).split("-").reverse().join("/") : "—");

// Etiqueta com estilos INLINE (fidelidade na janela de impressão)
export default function StockLabel({ item, widthMm = 60, heightMm = 40 }) {
  const qr = Math.max(Math.min(widthMm, heightMm) - 6, 10);
  const base = Math.max(heightMm * 0.075, 2.2);
  const row = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
  return (
    <div
      style={{
        width: `${widthMm}mm`,
        height: `${heightMm}mm`,
        display: "flex",
        alignItems: "stretch",
        background: "#fff",
        color: "#000",
        border: "0.3mm solid #999",
        fontFamily: "Arial, Helvetica, sans-serif",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
      data-testid="stock-label"
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5mm" }}>
        <QRCodeSVG
          value={buildQrPayload(item)}
          size={256}
          level="M"
          style={{ width: `${qr}mm`, height: `${qr}mm` }}
        />
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          padding: "1.5mm 1.5mm 1.5mm 0",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "0.4mm",
          fontSize: `${base}mm`,
          lineHeight: 1.25,
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: `${base * ((item.name || "").length > 40 ? 0.95 : (item.name || "").length > 22 ? 1.05 : 1.2)}mm`,
            lineHeight: 1.15,
            overflow: "hidden",
            wordBreak: "break-word",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.name}
        </div>
        <div style={row}>
          Peso:{" "}
          {item.unit_weight != null && item.unit_weight !== ""
            ? `${item.unit_weight} ${item.unit_weight_unit || "g"}`
            : "—"}
        </div>
        <div style={row}>Loc: {item.location || "—"}</div>
        <div style={row}>Prod.: {fmt(item.production_date)}</div>
        <div style={{ ...row, fontWeight: 700 }}>Val.: {fmt(item.expires_at)}</div>
        <div style={row}>Resp.: {item.responsible || "—"}</div>
      </div>
    </div>
  );
}

// Monta a janela de impressão via DOM API (sem document.write)
function openPrintWindow(containerEl, pageCss, title, delay, features) {
  if (!containerEl) return;
  const w = window.open("", "_blank", features);
  if (!w) return;
  const doc = w.document;
  doc.title = title;
  const style = doc.createElement("style");
  style.textContent = `${pageCss}html,body{margin:0;padding:0}`;
  doc.head.appendChild(style);
  for (const child of containerEl.childNodes) {
    doc.body.appendChild(doc.importNode(child, true));
  }
  setTimeout(() => {
    w.focus();
    w.print();
    w.close();
  }, delay);
}

// Impressão direta no tamanho exato da etiqueta (@page)
export function printStockLabel(containerEl, widthMm, heightMm) {
  openPrintWindow(
    containerEl,
    `@page{size:${widthMm}mm ${heightMm}mm;margin:0}`,
    "Etiqueta",
    400,
    "width=700,height=500"
  );
}

// Impressão em lote: várias etiquetas em folha A4
export function printLabelSheet(containerEl) {
  openPrintWindow(containerEl, "@page{size:A4;margin:8mm}", "Etiquetas", 500, "width=900,height=700");
}
